// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root___FRW7","label":"Completed_label__2HFup"};